module.exports = __webpack_public_path__ + "img/pet.69f12bd1.svg";